<template>
    <div>
        <el-dialog
            title="维护子项"
            :visible.sync="showDialog"
            width="741px"
            @close="closeDialog"
        >
            <div class="add-button">
                <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline" plain @click="addData">新增子项</el-button>
            </div>
            <div>
                <el-table
                    :data="dataList"
                    border
                    size="small"
                    style="width: 100%">
                    <el-table-column
                        prop="itemName"
                        label="子项类型"
                        align="center"
                        width="180">
                        <template slot-scope='scope'>
                            <el-select
                                v-model="scope.row.itemType"
                                placeholder="请选择"
                                size="small"
                                @change="disabledItem"
                            >
                                <el-option
                                    v-for="item in reportDataTypeEnumList"
                                    :key="item.key"
                                    :label="item.value"
                                    :value="item.key"
                                    :disabled="item.disabled">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="orientation"
                        label="方向"
                        align="center"
                        width="180">
                        <template slot-scope='scope'>
                            <el-select
                                v-model="scope.row.orientation"
                                placeholder="请选择"
                                size="small"
                            >
                                <el-option
                                    v-for="item in numberList"
                                    :key="item.key"
                                    :label="item.value"
                                    :value="item.key">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="sort"
                        label="排序"
                        align="center"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        align="center"
                        width="180">
                        <template slot-scope='scope'>
                            <el-button type="primary" size="mini" icon="el-icon-top" circle @click="upData(scope.row.id,scope.row.index)"></el-button>
                            <el-button type="primary" size="mini" icon="el-icon-bottom" circle @click="subtractData(scope.row.id)"></el-button>
                            <el-button type="danger" size="mini" @click="deleteItem(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div
                slot="footer"
                class="flex justify-end"
            >
                <el-button @click="closeDialog">关闭</el-button>
                <el-button
                    type="primary"
                    @click="onSubmit"
                >确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { get, post,postJson } from '@/utils/request.js';
export default {
    data(){
        return {
            reportTableId:'',
            showDialog: false,
            reportDataTypeEnumList: [], //子项枚举
            dataList: [], //列表数据
            numberList:[
                {
                    key:-1,
                    value: "减"
                },
                {
                    key:0,
                    value: "无操作"
                },
                {
                    key:1,
                    value: "加"
                }
            ]
        }
    },
    methods:{
        // 显示
        show(item,id){
            console.log('item',item)


            this.showDialog = true
            this.getReportDataTypeEnum();
            item = item.sort((a, b) => a.sort - b.sort);
            item.forEach((item)=>{
                this.dataList.push({
                    id: item.id,
                    itemType: item.itemType,
                    orientation: item.orientation,
                    sort: item.sort,
                })
            })
            this.reportTableId = id
        },

        // 子项获取枚举
        getReportDataTypeEnum(){
            get('/mpp/utils/getEnum',{enumType:'report_data_type'}).then((res)=>{
                if(res.success){
                    this.reportDataTypeEnumList = res.enumList
                    this.disabledItem();
                }
            })
        },

        // 重新排序
        sortData(){
            this.dataList.forEach((item,index)=>{
                item.sort = index + 1
            })
        },

        // 禁用下拉框
        disabledItem(){
            this.reportDataTypeEnumList.forEach((item)=>{
                item.disabled = false
            })
            const itemTypeList = this.dataList.map(item => item.itemType);
            for (let i = 0; i < this.reportDataTypeEnumList.length; i++) {
                for (let j = 0; j < itemTypeList.length; j++) {
                    if (this.reportDataTypeEnumList[i].key == itemTypeList[j]) {
                        this.reportDataTypeEnumList[i].disabled = true
                        break;
                    }
                }
            }
        },

        // 隐藏
        closeDialog(){
            this.dataList = []
            this.reportDataTypeEnumList = []
            this.showDialog = false
        },

        // 确认
        onSubmit(){
            let dataList = {
                id: this.reportTableId,
                itemList: this.dataList
            }
            postJson('/report/reporttableitem/batchEditItem',{...dataList}).then((res)=>{
                if(res.success && res.code){
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    this.closeDialog();
                    this.$emit('resetDialog')
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            })
            console.log("请求格式",this.dataList)
        },

        // 删除子项
        deleteItem(id){
            for (let i = 0; i < this.dataList.length; i++) {
                if(this.dataList[i].id == id){
                    console.log('删除的子项是:',this.dataList[i])
                    this.dataList.splice(i,1)
                    this.sortData();
                    return
                }
            }
        },

        // 加
        upData(id,index){
            console.log('index',index)
            for (let i = 0; i < this.dataList.length; i++) {
                if(this.dataList[i].id == id && i != 0){
                    let exchange = this.dataList[i - 1]
                    this.dataList[i - 1] = this.dataList[i]
                    this.dataList[i] = exchange;
                    this.sortData();
                    return
                }
            }
        },

        // 减
        subtractData(id){
            for (let i = 0; i < this.dataList.length; i++) {
                if(this.dataList[i].id == id && i != this.dataList.length - 1){
                    let exchange = this.dataList[i + 1]
                    this.dataList[i + 1] = this.dataList[i]
                    this.dataList[i] = exchange;
                    this.sortData();
                    return
                }
            }
        },

        // 新增
        addData(){
            const date = new Date().getTime();
            this.dataList.push({
                id: 'a' + date,
                itemType: null,
                orientation: 0,
                sort: this.dataList.length + 1
            })
            this.disabledItem();
            console.log('idididididid',this.dataList)
        }
    }
}
</script>
<style scoped lang="scss">
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
    .add-button{
        display: flex;
        flex-direction: row;
        justify-content: right;
    }
</style>
